var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2300_5455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.561 0H2.43902C1.09199 0 0 1.09199 0 2.43902V27.561C0 28.908 1.09199 30 2.43902 30H27.561C28.908 30 30 28.908 30 27.561V2.43902C30 1.09199 28.908 0 27.561 0Z",
    fill: "#314D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6898 15.8195L9.81481 20.6945L8.73199 19.6105L13.6065 14.7361L8.73199 9.86131L9.81504 8.77826L14.69 13.6527L19.5643 8.77826L20.6483 9.86131L15.7733 14.7363L20.6483 19.6108L19.5643 20.6948L14.6898 15.8195Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2300_5455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultClose);
export default __webpack_public_path__ + "static/media/default_Close.1159d924ad9ad26bb4b0dc642c918c7e.svg";
export { ForwardRef as ReactComponent };